<template>
  <div class="customer-detail">
    <div class="customer-header pt-0">
      <slot name="header"></slot>

      <div class="text-xs-center">
        <v-avatar size="100">
          <v-img
            :lazy-src="user.profile_pic"
            :src="user.profile_pic"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <div class="spinner text-xs-center">
                  <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
                </div>
              </v-layout>
            </template>
          </v-img>
        </v-avatar>
        <div class="text-xs-center mt-2" style="color: white">
          {{ user.first_name ? user.first_name : '' }} {{ user.last_name ? user.last_name : '' }}
        </div>
        <div class="mb-4 text-xs-center">
          <template v-if="selectedBot.theme == 'ecommercebasic' && shoplink">
            <v-btn :href="shoplink" target="_blank" small depressed round outline dark>
              <v-icon class="mr-1" small>shopping_cart</v-icon>
              {{ $t('create_order') }}
            </v-btn>
          </template>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Channel') }}</label>
          <p>
            <span style="color: #3b5998" v-if="user.app == 'facebook'">
              <i class="fab fa-facebook-square"></i> Facebook
            </span>
            <span style="color: #00c300" v-else-if="user.app == 'line'">
              <i class="fab fa-line"></i> Line
            </span>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('gender') }}</label>
          <p>{{ $t(user.gender) }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Locale') }}</label>
          <p>
            <template v-if="userLocale">
              <flag :iso="userLocale.icon" />
              {{ userLocale.title }}
            </template>
            <template v-else>-</template>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Status') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['status']"
                :userid="user.id"
                :placeholder="$t('Status')"
                @onEdit="onEditStatus"
              >
                <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Address') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['address']"
                :userid="user.id"
                :placeholder="$t('Address')"
                @onEdit="onEditAddress"
              >
                <customer-item-value :value="user['address']">{{
                  user.address
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Register Date') }}</label>
          <p>
            {{ user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-' }}
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Last Active Date') }}</label>
          <p>{{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Email') }}</label>
          <p>
            <edit-customer-value
              v-model="user['email']"
              :userid="user.id"
              :placeholder="$t('Email')"
              @onEdit="onEditEmail"
            >
              <customer-item-value :value="user['email']">{{ user.email }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('phone no.') }}</label>
          <p>
            <edit-customer-value
              v-model="user['phoneno']"
              :userid="user.id"
              :placeholder="$t('phone no.')"
              @onEdit="onEditPhone"
            >
              <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Context') }}</label>
          <p>
            <edit-customer-value
              v-model="user['context']"
              :userid="user.id"
              :placeholder="$t('Context')"
              @onEdit="onEditContext"
            >
              <customer-item-value :value="user['context']">{{ user.context }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Line ID') }}</label>
          <p>
            <edit-customer-value
              v-model="user['lineid']"
              :userid="user.id"
              :placeholder="$t('Line ID')"
              @onEdit="onEditLineId"
            >
              <customer-item-value :value="user['lineid']">{{ user.lineid }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('School') }}</label>
          <p>
            <edit-customer-school
              v-model="user['school']"
              :userid="user.id"
              :placeholder="$t('School')"
              @onEdit="onEditSchool"
            >
              <customer-item-value :value="user['school']">{{ user.school }}</customer-item-value>
            </edit-customer-school>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Province') }}</label>
          <p>
            <edit-customer-value
              v-model="user['province']"
              :userid="user.id"
              :placeholder="$t('Province')"
              @onEdit="onEditProvince"
            >
              <customer-item-value :value="user['province']">{{
                user.province
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <div class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>
          {{ $t('Tag') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </label>

        <a
          href="javascript:void(0);"
          v-if="$store.getters.getPackage == 'premium' && !isEditTag && !isCoachlab"
          @click="isEditTag = true"
        >
          <v-icon small color="primary">edit</v-icon>
        </a>
      </div>
      <div class="pl-3 pr-3 pt-2 pb-2">
        <template v-if="!isEditTag">
          <div class="left-align" v-if="tags.length == 0">{{ $t('No tag') }}</div>
          <ul class="tags">
            <li class="tag" v-for="(tag, index) in tags" :key="'usertag_' + index">
              <specialtext :text="tag"></specialtext>
            </li>
          </ul>
        </template>
        <template v-else>
          <tags
            v-model="usertag"
            :tags="usertags"
            @tags-changed="addUserTags"
            @before-adding-tag="checkUserTags"
            style="margin-bottom: 5px"
            :btnText="$t('Add tag')"
          ></tags>

          <div class="text-xs-center" style="margin-top: 15px">
            <v-btn outline color="grey" small @click="cancelEditTag">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="saveEditTag">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </div>

      <v-divider></v-divider>
      <div class="pl-3 pr-3 pt-2 pb-2" v-if="userSession">
        <div class="mb-2">
          <label class="caption">
            {{ $t('Data Summary') }}
          </label>
          <a href="javascript:void(0);" v-if="!isEditSession" @click="isEditSession = true">
            <v-icon>edit</v-icon>
          </a>
        </div>
        <template>
          <div
            v-if="typeof userSession === 'object'"
            style="
              overflow-y: auto;
              max-height: 300px;
              padding: 5px;
              background: #f7f7f7;
              border: 1px solid #eee;
              border-radius: 5px;
            "
          >
            <template>
              <template>
                <div
                  :key="`key${index}`"
                  v-for="(value, name, index) in userSession"
                  style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                >
                  <v-btn
                    icon
                    v-if="isEditSession"
                    style="float: right;"
                    @click="deleteSession(name)"
                    ><v-icon color="primary">delete</v-icon></v-btn
                  >
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <template>
                        <span style="color:#FF706B">{{ name }}</span></template
                      ></v-flex
                    >
                    <v-flex xs12 sm6 class="form-control">
                      <template v-if="!isEditSession">{{ value }}</template>
                      <input v-else type="text" v-model="userSession[name]"
                    /></v-flex>
                  </v-layout>
                </div>
              </template>
            </template>
          </div>
          <div v-else>
            <p>{{ userSession }}</p>
          </div>
          <div class="text-xs-center mt-2" v-if="isEditSession">
            <v-btn outline color="grey" small @click="cancleEditSession">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="editSession">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </div>
      <v-divider v-if="userSession"></v-divider>
      <div v-if="!getuseronly" class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Message Sent') }}</label>
        <div style="position: relative" margin-top="25">
          <div v-if="!selectedBot.status">
            <div class="text-xs-center my-3">
              <v-card
                max-width="600"
                style="margin: auto;border-radius: 10px"
                flat
                class="grey lighten-4"
              >
                <v-card-text>
                  <h2 style="text-shadow: 1px 1px 20px #9e9e9e;" class="display-1">
                    {{ $t('If you want to test, please activate your bot') }}
                  </h2>
                  <p>
                    {{
                      $t('Information will not be recorded in analytics if the bot is inactivated')
                    }}
                  </p>

                  <v-btn
                    depressed
                    style="margin-bottom:1.5em"
                    @click="toggleBotStatus"
                    small
                    color="primary"
                    >{{ $t('Click for starting your Bot') }}</v-btn
                  >
                </v-card-text>
              </v-card>
            </div>
          </div>
          <template v-else>
            <v-premium-plan-popup
              :showAll="false"
              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            ></v-premium-plan-popup>
            <div
              style="
              overflow-y: auto;
              max-height: 300px;
              padding: 5px;
              background: #f7f7f7;
              border: 1px solid #eee;
              border-radius: 5px;
            "
            >
              <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
                <div
                  v-for="(intent, index) in 10"
                  :key="'intent_' + index"
                  style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                >
                  <div
                    style="
                    height: 15px;
                    position: relative;
                    top: 3px;
                    display: inline-block;
                    width: 100%;
                    max-width: 100px;
                    background-color: #eee;
                  "
                  ></div>
                </div>
              </template>
              <template v-else>
                <template v-if="filterIntent.length > 0">
                  <div
                    v-for="(intent, index) in filterIntent"
                    :key="'intent_' + index"
                    style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                  >
                    <template v-if="$store.getters.getPackage == 'premium' && !isCoachlab">
                      <template v-if="intent.name === '{default}'">{{
                        $t('Default Conversation')
                      }}</template>
                      <template v-else-if="intent.name === '{welcome}'">{{
                        $t('Welcome Message')
                      }}</template>
                      <template v-else-if="intent.name === '{default_comment_to_inbox}'">{{
                        $t('More Comment to Inbox')
                      }}</template>
                      <template v-else-if="intent.name == null">{{ $t('Other') }}</template>
                      <template v-else>{{ intent.name }}</template>
                      ({{ intent.count | numberFormat }})
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="text-center">{{ $t('No message sent') }}</div>
                </template>
              </template>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CustomerDetail from './CustomerDetail.js'

export default {
  mixins: [CustomerDetail]
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/dashboard/CustomerDetail.vue